<template>
    <div class="each-component">
        <div class="flex-center position-ref full-height">
            <div class="text-left padding-x30">
                <h1>Page Not Found</h1>
                <p>The page you requested could not be found, either contact your admin contact or try again.</p>
                <p>
                    Use your browsers Back button to navigate to the page you have previously come from or use the menus to navigate somewhere else.</p>
            </div>
        </div>
    </div>
</template>


<script>
    export default {
        created() {
            this.$root.loading = false;
        }
    }
</script>


<style lang="css" scoped>

    .full-height {
        height: 80vh;
    }

    .flex-center {
        align-items: center;
        display: flex;
        justify-content: center;
    }

    .position-ref {
        position: relative;
    }

</style>